// Export the Component Definition for use in Contentful Studio
export {ButtonLegacyContentfulComponentDefinition} from './ButtonLegacyContentfulDefinition';
export {default} from './ButtonLegacy';
